import type { QFastTimerange } from "../../stores/qfast-store";

export const QFAST_DASHBOARD_PROP = "qfast_dashboard";

/** User IDs allowed to access QFast (in addition to root). */
export const QFAST_WHITELISTED_USER_IDS = [22391, 19608, 23376, 23388] as const;

const QFAST_WHITELISTED_SET = new Set(QFAST_WHITELISTED_USER_IDS);

export const canAccessQFast = (userStore: { isRoot: () => boolean; user?: { id?: number } }) =>
    // @ts-ignore
    userStore.isRoot() || (userStore.user?.id != null && QFAST_WHITELISTED_SET.has(userStore.user.id));

export const VOTERS_PAGE_SIZES = [25, 50, 100, 200] as const;

/** Agg keys used for timeline/surveyors only; excluded from dimension agg cards. */
export const QFAST_RESERVED_AGG_KEYS = ["surveyor_id", "dt_full_date"];

/** Filter key for enumerator (surveyor) filter; value is surveyor id. */
export const QFAST_ENUMERATOR_FILTER_KEY = "surveyor_id";
/** Filter key for completion age range filter. */
export const QFAST_AGE_RANGE_FILTER_KEY = "age_range";

export const QFAST_ERROR_MESSAGES = {
    notConfigured:
        "QFast Dashboard is not configured for this project. Please set the qfast_dashboard property in project settings.",
    backToDashboard: "Back to project dashboard",
};

export const QFAST_TIME_FILTERS: Array<{ key: QFastTimerange; label: string }> = [
    { key: "today", label: "Today" },
    { key: "yesterday", label: "Yesterday" },
    { key: "last_7_days", label: "Last 7 Days" },
    { key: "last_30_days", label: "Last 30 Days" },
    { key: "last_3_months", label: "Last 3 Months" },
    { key: "last_year", label: "Last Year" },
    { key: "year_to_date", label: "Year to Date" },
    { key: "all", label: "All" },
];
